import { CcRequirementPriority } from "server/models"

export type CcRequirementPriorityValidation = { [key in keyof CcRequirementPriority]?: string}
export interface CcRequirementPriorityList { [priorityId: number]: CcRequirementPriority }

export interface CcRequirementPriorityState {
    priorityList: CcRequirementPriorityList
    priorityIds: readonly number[]
    priorityEdit: CcRequirementPriority

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_REQUIREMENT_PRIORITY_LIST = "CC_REQUIREMENT_PRIORITY_LIST"
export const CC_REQUIREMENT_PRIORITY_IDS = "CC_REQUIREMENT_PRIORITY_IDS"
export const CC_REQUIREMENT_PRIORITY_EDIT = "CC_REQUIREMENT_PRIORITY_EDIT"

export const CC_REQUIREMENT_PRIORITY_RELOAD_LIST = "CC_REQUIREMENT_PRIORITY_RELOAD_LIST"
export const CC_REQUIREMENT_PRIORITY_RELOAD_EDIT = "CC_REQUIREMENT_PRIORITY_RELOAD_EDIT"
